import Stack from "@mui/material/Stack";

import useVariant from "hooks/useVariant";
import useUpdateVariant from "hooks/useUpdateVariant";
import useVariantsFilter from "hooks/useVariantsFilter";
import useGtagVariantData from "hooks/useGtagVariantData";
import useDistinctVariantTypes from "hooks/useDistinctVariantTypes";
import ToggleButton from "./ToggleButton";
import { getWasmMethods } from "@3ds/3DEXCITEshow-streaming";

const batterySorter = (a: string, b: string) => parseInt(b) - parseInt(a);

const wheelSorter = (a: string, b: string) =>
  parseInt(b.replaceAll(/[^0-9]/g, "")) - parseInt(a.replaceAll(/[^0-9]/g, ""));

export default function WheelSelector() {
  const wasmMethods = getWasmMethods();

  const variant = useVariant();
  const filteredVariants = useVariantsFilter({ code: variant?.code, variant: variant?.variant });
  const wheels = useDistinctVariantTypes("wheels", filteredVariants, wheelSorter);
  const updateVariant = useUpdateVariant();
  const getGtagData = useGtagVariantData();

  const selectedWheel = wheels.find(({ selected }) => selected);

  const batteries = useDistinctVariantTypes("battery", filteredVariants, batterySorter);

  const selectedBattery = batteries.find(({ selected }) => selected);

  const handleChange = async (newValue: string) => {
    if (selectedWheel?.code === newValue) return;

    const battery = parseInt(selectedBattery?.code?.match(/\d+/)[0], 10).toString();

    const filteredObject = filteredVariants?.filter(
      (item) =>
        item?.id?.includes(battery) &&
        item?.id?.toLowerCase()?.includes(newValue?.toLowerCase().toLowerCase()),
    );

    // if (isTurntable) {
    //   setTurntableState((prev) => ({
    //     ...prev,
    //     selectedVariants: [...prev.selectedVariants, filteredObject[0]?.friendly_name],
    //   }));
    // }

    try {
      if (wasmMethods && "switchVariants" in wasmMethods) {
        await wasmMethods?.switchVariants(filteredObject[0]?.friendly_name);
      }
    } catch (ex) {
      console.log(ex, " switch variant cordis error");
    }

    updateVariant({ wheels: newValue }, filteredVariants);
    window.gtag(
      "event",
      "variant_change",
      getGtagData("model", `Change variant (Wheels) to ${newValue}`),
    );
  };

  return (
    <Stack mt={1.5} mb={0.5} direction="row" columnGap={2} rowGap={2} width="100%" flexWrap="wrap">
      {wheels.map((value) => (
        <ToggleButton
          key={value.code}
          selected={value.code === selectedWheel?.code}
          ButtonProps={{ onClick: () => handleChange(value.code) }}
        >
          {value.code}
        </ToggleButton>
      ))}
    </Stack>
  );
}
